// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3041": "8f5c5b96","3046": "b63cef43","9180": "645340aa",}[chunkId] + ".css"
}